// extracted by mini-css-extract-plugin
export default {"name":"email_name__cKppQ","email":"email_email__7oPiV","tel":"email_tel__nCsQI","btn":"email_btn__ZXr0F","subTitel":"email_subTitel__mIuSI"};